import { Component, OnInit, Input, PipeTransform, Pipe } from '@angular/core';
import { FormGroup, FormArray } from '@angular/forms';
import { startWith } from 'rxjs/operators';

@Component({
  selector: 'app-side-preview',
  templateUrl: './side-preview.component.html',
  styleUrls: ['./side-preview.component.scss']
})
export class SidePreviewComponent implements OnInit {

  @Input() elements: any;
  @Input() laudo: any;
  @Input() form: FormArray | FormGroup;
  cards = [];
  dianteira: { title: string; totalErros: number; elements: any[]; };
  direita: { title: string; totalErros: number; elements: any[]; };
  esquerda: { title: string; totalErros: number; elements: any[]; };
  traseira: { title: string; totalErros: number; elements: any[]; };
  constructor() { }

  cardDianteiraElementName = [
    "dLongarinaEsquerda",
    "dLongarinaDireita",
    "painel",
    "painelCortaFogo",
    "paraLamaInternoEsquerdo",
    "paraLamaInternoDireito",
    "dTorreAmortecedorEsquerdo",
    "dTorreAmortecedorDireito",
    "numeroMotor",
    "numeroChassiDianteira",
    "etiquetaMotor",
    "gravacaoParaBrisa",
    "plaquetaChassiDianteira",
    "plaquetaCarrocaria",
    "paraChoqueDianteiro",
    "paraLamaDianteiroDireito",
    "paraLamaDianteiroEsquerdo",
    "capo",
  ];

  cardDireitaElementName = [
    "ldColunaDianteira",
    "ldColunaCentral",
    "ldColunaTraseira",
    "ldCaixaAr",
    "estruturaLateralTraseiraDireita",
    "numeroChassiDireita",
    "etiquetaETA",
    "ldGravacaoVidroPortaDianteira",
    "ldFabricacaoVidroPortaDianteira",
    "ldGravacaoVidroPortaTraseira",
    "ldFabricacaoVidroPortaTraseira",
    "ldGravacaoVidroLateralTraseira",
    "ldFabricacaoVidroLateralTraseira",
    "ldTraseira",
    "ldPortaDianteira",
    "ldPortaTraseira",
  ];

  cardEsquerdaElementName = [
    "leColunaDianteira",
    "leColunaCentral",
    "leColunaTraseira",
    "leCaixaAr",
    "estruturaLateralTraseiraEsquerda",
    "numeroChassiEsquerda",
    "leGravacaoVidroPortaDianteira",
    "leGravacaoVidroPortaTraseira",
    "leGravacaoVidroLateralTraseira",
    "lePortaDianteira",
    "lePortaTraseira",
    "leTraseira",
  ];

  cardTraseiraElementName = [
    "tLongarinaEsquerda",
    "tLongarinaDireita",
    "painelTraseiro",
    "tetoEstrutura",
    "tTorreAmortecedorEsquerdo",
    "tTorreAmortecedorDireito",
    "assoalhoPortaMalas",
    "caixaEstepe",
    "caixaRodaEsquerda",
    "caixaRodaDireita",
    "numeroChassiTraseira",
    "gravacaoVidroTraseiro",
    "plaquetaChassiTraseira",
    "capoTraseiro",
    "paraLamaTraseiroEsquerdo",
    "paraLamaTraseiroDireito",
    "paraChoqueTraseiro",
    "tetoPintura",
  ];

  car = {
    portaDianteiraDireita: null,
    portaDianteiraEsquerda: null,
    portaTraseiraDireita: null,
    portaTraseiraEsquerda: null,
    lateralTraseiraDireita: null,
    lateralTraseiraEsquerda: null,
    paraLamaEsquerda: null,
    paraLamaDireita: null,
    capo: null,
    teto: null,
    tampaPortaMalas: null,
    paraChoqueDianteira: null,
    paraChoqueTraseira: null,
  };

  ngOnInit() {
    this.setCardItens();
    let empty = { status: 0 };
    this.car.portaDianteiraDireita = this.elements["ldPortaDianteira"] || empty;
    this.car.portaDianteiraEsquerda = this.elements["lePortaDianteira"] || empty;
    this.car.portaTraseiraDireita = this.elements["ldPortaTraseira"] || empty;
    this.car.portaTraseiraEsquerda = this.elements["lePortaTraseira"] || empty;
    this.car.lateralTraseiraDireita = this.elements["ldTraseira"] || empty;
    this.car.lateralTraseiraEsquerda = this.elements["leTraseira"] || empty;
    this.car.paraLamaEsquerda = this.elements["paraLamaDianteiroEsquerdo"] || empty;
    this.car.paraLamaDireita = this.elements["paraLamaDianteiroDireito"] || empty;
    this.car.capo = this.elements["capo"] || empty;
    this.car.teto = this.elements["tetoPintura"] || empty;
    this.car.tampaPortaMalas = this.elements["capoTraseiro"] || empty;
    this.car.paraChoqueDianteira = this.elements["paraChoqueDianteiro"] || empty;
    this.car.paraChoqueTraseira = this.elements["paraChoqueTraseiro"] || empty;
  }

  ngOnChanges() {

  }

  setTotalErros() {
    this.cards.forEach(c => {
      c.totalErros = c.elements.filter(e => (e.status > 1)).length;
    })
  }

  setCardItens() {

    this.dianteira = {
      title: 'Dianteira', totalErros: 0,
      elements: this.cardDianteiraElementName.map(name => this.elements[name]).filter(v => v)
    };
    this.direita = {
      title: 'Lateral Direita', totalErros: 0,
      elements: this.cardDireitaElementName.map(name => this.elements[name]).filter(v => v)
    };
    this.esquerda = {
      title: 'Lateral Esquerda', totalErros: 0,
      elements: this.cardEsquerdaElementName.map(name => this.elements[name]).filter(v => v)
    };
    this.traseira = {
      title: 'Traseira', totalErros: 0,
      elements: this.cardTraseiraElementName.map(name => this.elements[name]).filter(v => v)
    };

    this.cards = [
      this.dianteira,
      this.direita,
      this.esquerda,
      this.traseira
    ];

    this.form.valueChanges.pipe(startWith(this.form.value)).subscribe(f => {
      this.setTotalErros();
    })
  }



}
